﻿import { StringEditor, Widget, PrefixedContext, initFormType } from "@serenity-is/corelib";

export interface MoveDocumentsForm {
    DocumentIds: StringEditor;
    TargetPath: Widget;
}

export class MoveDocumentsForm extends PrefixedContext {
    static readonly formKey = 'Cemdo.Default.MoveDocumentsRequest';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!MoveDocumentsForm.init)  {
            MoveDocumentsForm.init = true;

            var w0 = StringEditor;
            var w1 = Widget;

            initFormType(MoveDocumentsForm, [
                'DocumentIds', w0,
                'TargetPath', w1
            ]);
        }
    }
}